// Badge affiché dans l'en-tête : un admin doit toujours savoir s'il agit sur la production
export const ENV_LABEL: string =
  (import.meta.env['VITE_PLATFORM_ENV'] as string | undefined)?.toUpperCase() || (import.meta.env.PROD ? 'PROD' : 'LOCAL');

export const isProdEnv = (label: string = ENV_LABEL): boolean => label === 'PROD';
